/**
 * TokenDetailSkeleton — Full page shimmer skeleton matching the token detail layout.
 *
 * Story 4.2 — Task 5
 */

import { CreatorInfoSkeleton } from "./CreatorInfo";
import { StatsGridSkeleton } from "./StatsGrid";
import { TokenHeaderSkeleton } from "./TokenHeader";

export function TokenDetailSkeleton() {
	return (
		<div className="mx-auto max-w-7xl px-4 py-8">
			<div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-8">
				<div className="space-y-6">
					<TokenHeaderSkeleton />
					<StatsGridSkeleton />
				</div>
				<div>
					<CreatorInfoSkeleton />
				</div>
			</div>
		</div>
	);
}
